import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { CheckCircle2 } from "lucide-react";
import { clearBusinessSignupImages, clearBusinessSignupPending } from "./businessSignupState";

const BusinessSuccessPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const loggedIn = useSelector((state: any) => state.auth.loggedIn);

  useEffect(() => {
    clearBusinessSignupImages();
    clearBusinessSignupPending();
  }, []);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gradient-to-br from-[#fff3e0] to-[#ffe0b2] p-4">
      <div className="w-full max-w-md rounded-2xl bg-white p-10 text-center shadow-xl">
        <span className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-[#fff3e0] text-[#ffa217]">
          <CheckCircle2 size={44} />
        </span>
        <div className="mt-6 text-2xl font-extrabold text-[#333]">
          {loggedIn
            ? t("REGISTERED SUCCESSFULLY")
            : t("Awaiting admin approval")}
        </div>
        <p className="mt-2 text-sm text-gray-500">
          {loggedIn
            ? t("Welcome to Uninfo HK. Your account is ready!")
            : t(
                "Your registration has been submitted for admin review. You will be able to log in once it is approved.",
              )}
        </p>
        <button
          type="button"
          onClick={() => navigate(loggedIn ? "/portal" : "/")}
          className="mt-8 w-full rounded-lg bg-[#ffa217] py-3 font-bold text-white transition hover:bg-[#e08f0e]"
        >
          {loggedIn ? t("EXPLORE NOW") : t("Login")}
        </button>
      </div>
    </div>
  );
};

export default BusinessSuccessPage;
